export const meta = {
  id: 'stooge-sort',
  name: 'Stooge Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n^2.709)',
    space: 'O(n)'
  },
  description: 'Stooge Sort is a recursive sorting algorithm with poor time complexity. Sorts by dividing array into thirds and recursively sorting first two, last two, then first two again.'
};
